import Login from "../pages/Login/Login";
import ForgotPassword from "../components/ForgotPassword/ForgotPassword";
import ResetPassword from "../components/ResetPassword/ResetPassword";

import Dashboard from "../pages/Dashboard/Dashboard";
import ChangePassword from "../components/ChangePassword/ChangePassword";
import Profile from "../components/Profile/Profile";

import ViewAllSettings from "../components/Settings/ViewAll";
import ViewPrefix from "../components/Settings/ViewPrefix";
import AddSetting from "../components/Settings/Add";
import EditSetting from "../components/Settings/Edit";
import ViewAllCms from "../components/Cms/ViewAll";
import ViewOneCms from "../components/Cms/NewViewOne";
import AddCms from "../components/Cms/NewAdd";
import EditCms from "../components/Cms/NewEdit";
import ViewAllEmailTemplate from "../components/EmailTemplate/ViewAll";
import AddEmailTemplate from "../components/EmailTemplate/Add";
import EditEmailTemplate from "../components/EmailTemplate/Edit";
import ViewAllEmailLogs from "../components/EmailLog/ViewAll";
import ViewAllAthletes from "../components/Athletes/ViewAll";
import AddAthlete from "../components/Athletes/Add";
import EditAthlete from "../components/Athletes/Edit";
import ViewAthlete from "../components/Athletes/ViewOne";
import ChangePasswordAthlete from "../components/Athletes/ChangePassword";
import ViewAllFaqs from "../components/Faq/ViewAll";
import AddFaq from "../components/Faq/Add";
import EditFaq from "../components/Faq/Edit";
import AddImage from "../components/Image/Add";
import ViewAllImage from "../components/Image/ViewAll";
import EditImage from "../components/Image/Edit";
import SeoPageAdd from "../components/SeoPage/Add";
import SeoPageViewAll from "../components/SeoPage/ViewAll";
import SeoPageEdit from "../components/SeoPage/Edit";

import ViewAllContactUs from "../components/ContactUs/ViewAll";
import ViewAllSports from "../components/Sports/ViewAll";
import SportAdd from "../components/Sports/Add";
import SportEdit from "../components/Sports/Edit";

import ViewAllCoaches from "../components/Coaches/ViewAll";
import AddCoach from "../components/Coaches/Add";
import EditCoach from "../components/Coaches/Edit";
import ViewCoach from "../components/Coaches/ViewOne";
import ChangePasswordCoach from "../components/Coaches/ChangePassword";

import ViewAllClubs from "../components/Clubs/ViewAll";
import AddClub from "../components/Clubs/Add";
import EditClub from "../components/Clubs/Edit";
import ViewClub from "../components/Clubs/ViewOne";
import ChangePasswordClub from "../components/Clubs/ChangePassword";

import ViewAllPlans from "../components/Plan/ViewAll";
import AddPlan from "../components/Plan/Add";
import EditPlan from "../components/Plan/Edit";

import ViewAllSubscriptions from "../components/Subscription/ViewAll";
import ViewAllTransactions from "../components/Transactions/ViewAll";
import ViewAllRPEColorCoding from "../components/RPEColorCoding/ViewAll";
import ViewAllLanguage from "../components/LanguageSetting/ViewAll";
import AddLanguage from "../components/LanguageSetting/Add";
import EditLanguage from "../components/LanguageSetting/Edit";

/*new work start */

import HomeRoleAdd from "../components/Home/Roles/Add";
import HomeRoleViewAll from "../components/Home/Roles/ViewAll";
import HomeRoleEdit from "../components/Home/Roles/Edit";
import HomeBannerAdd from "../components/Home/Banner/Add";
import FeaturesAdd from "../components/Features/Add";
import FeaturesViewAll from "../components/Features/ViewAll";
import FeaturesEdit from "../components/Features/Edit";
import ViewAll from "../components/AboutUs/Teams/ViewAll";
import Add from "../components/AboutUs/Teams/Add";
import Edit from "../components/AboutUs/Teams/Edit";
import ResourcesViewAll from "../components/Resources/Videos/ViewAll";
import ResourcesAdd from "../components/Resources/Videos/Add";
import ResourcesEdit from "../components/Resources/Videos/Edit";
import DocumentViewAll from "../components/Resources/Documents/ViewAll";
import DocumentAdd from "../components/Resources/Documents/Add";
import DocumentEdit from "../components/Resources/Documents/Edit";

// import GettingStartedCoachAdd from "../components/GettingStarted/GuideForCoach/Add";
// import GettingStartedCoachViewAll from "../components/GettingStarted/GuideForCoach/ViewAll";
// import GettingStartedCoachEdit from "../components/GettingStarted/GuideForCoach/Edit";

import GettingStartedCoachViewAll from "../components/GettingStarted/GuideForCoach/Scenario-1/ViewAll";
import GettingStartedCoachAdd from "../components/GettingStarted/GuideForCoach/Scenario-1/Add";
import GettingStartedCoachEdit from "../components/GettingStarted/GuideForCoach/Scenario-1/Edit";

import GettingStartedscenario2CoachAdd from "../components/GettingStarted/GuideForCoach/Scenario-2/Add";
import GettingStartedscenario2CoachEdit from "../components/GettingStarted/GuideForCoach/Scenario-2/Edit";
import GettingStartedCoachscenario2ViewAll from "../components/GettingStarted/GuideForCoach/Scenario-2/ViewAll";

import GettingStartedOrganizationViewAll from "../components/GettingStarted/GuideForSportOrganization/ViewAll";
import GettingStartedOrganizationAdd from "../components/GettingStarted/GuideForSportOrganization/Add";
import GettingStartedOrganizationEdit from "../components/GettingStarted/GuideForSportOrganization/Edit";

import GettingStartedAthleteViewAll from "../components/GettingStarted/GuideForAthlete/ViewAll";
import GettingStartedAthleteAdd from "../components/GettingStarted/GuideForAthlete/Add";
import GettingStartedAthleteEdit from "../components/GettingStarted/GuideForAthlete/Edit";

import AddCurrency from "../components/Currency/Add";
import EditCurrency from "../components/Currency/Edit";
import ViewAllCurrency from "../components/Currency/ViewAll";
/*new work end */

export const privateRoutes = [
  { path: "/", component: Dashboard },
  { path: "/setting", component: ViewAllSettings },
  { path: "/setting/prefix/:prefix", component: ViewPrefix },
  { path: "/setting/add", component: AddSetting },
  { path: "/setting/edit/:id", component: EditSetting },
  { path: "/cms", component: ViewAllCms },
  { path: "/cms/view/:id", component: ViewOneCms },
  { path: "/cms/add", component: AddCms },
  { path: "/cms/edit/:id", component: EditCms },
  { path: "/email-template", component: ViewAllEmailTemplate },
  { path: "/email-template/add", component: AddEmailTemplate },
  { path: "/email-template/edit/:id", component: EditEmailTemplate },
  { path: "/email-logs", component: ViewAllEmailLogs },
  { path: "/change-password", component: ChangePassword },
  { path: "/my-profile", component: Profile },
  { path: "/athletes", component: ViewAllAthletes },
  { path: "/athletes/add", component: AddAthlete },
  { path: "/athletes/edit/:id", component: EditAthlete },
  { path: "/athletes/view/:id", component: ViewAthlete },
  { path: "/athletes/change-password/:id", component: ChangePasswordAthlete },

  { path: "/coaches", component: ViewAllCoaches },
  { path: "/coach/add", component: AddCoach },
  { path: "/coach/edit/:id", component: EditCoach },
  { path: "/coach/view/:id", component: ViewCoach },
  { path: "/coach/change-password/:id", component: ChangePasswordCoach },

  { path: "/clubs", component: ViewAllClubs },
  { path: "/club/add", component: AddClub },
  { path: "/club/edit/:id", component: EditClub },
  { path: "/club/view/:id", component: ViewClub },
  { path: "/club/change-password/:id", component: ChangePasswordClub },

  { path: "/faq", component: ViewAllFaqs },
  { path: "/faq/add", component: AddFaq },
  { path: "/faq/edit/:id", component: EditFaq },

  { path: "/system-images/add", component: AddImage },
  { path: "/system-images", component: ViewAllImage },
  { path: "/system-images/edit/:id", component: EditImage },

  { path: "/seo-pages", component: SeoPageViewAll },
  { path: "/seo-page/add", component: SeoPageAdd },
  { path: "/seo-page/edit/:id", component: SeoPageEdit },

  { path: "/plans", component: ViewAllPlans },
  { path: "/plan/add", component: AddPlan },
  { path: "/plan/edit/:id", component: EditPlan },

  { path: "/subscriptions", component: ViewAllSubscriptions },
  { path: "/transactions", component: ViewAllTransactions },

  { path: "/contact-us", component: ViewAllContactUs },

  { path: "/sports", component: ViewAllSports },
  { path: "/sport/add", component: SportAdd },
  { path: "/sport/edit/:id", component: SportEdit },

  { path: "/rpe-color-codes", component: ViewAllRPEColorCoding },

  { path: "/language-setting", component: ViewAllLanguage },
  { path: "/language-setting/add", component: AddLanguage },
  { path: "/language-setting/edit/:id", component: EditLanguage },

    { path: "/currency/add", component: AddCurrency},
  { path: "/currency/edit/:id", component: EditCurrency},
  { path: "/currencies", component: ViewAllCurrency},

  /* new work start */
  { path: "/home/roles", component: HomeRoleViewAll },
  { path: "/home/role/add", component: HomeRoleAdd },
  { path: "/home/role/edit/:id", component: HomeRoleEdit },
  { path: "/home/banner", component: HomeBannerAdd },
  { path: "/features", component: FeaturesViewAll },
  { path: "/feature/add", component: FeaturesAdd },
  { path: "/feature/edit/:id", component: FeaturesEdit },
  { path: "/about-us/teams", component: ViewAll },
  { path: "/about-us/team/add", component: Add },
  { path: "/about-us/team/edit/:id", component: Edit },
  { path: "/resources/video", component: ResourcesViewAll },
  { path: "/resources/video/add", component: ResourcesAdd },
  { path: "/resources/video/edit/:id", component: ResourcesEdit },
  { path: "/resources/document", component: DocumentViewAll },
  { path: "/resources/document/add", component: DocumentAdd },
  { path: "/resources/document/edit/:id", component: DocumentEdit },
  { path: "/getting-started/guide-for-sport-organization", component: GettingStartedOrganizationViewAll },
  { path: "/getting-started/guide-for-sport-organization/add", component: GettingStartedOrganizationAdd},
  { path: "/getting-started/guide-for-sport-organization/edit/:id", component: GettingStartedOrganizationEdit},

  { path: "/getting-started/guide-for-coach/scenario-1/add", component: GettingStartedCoachAdd },
  { path: "/getting-started/guide-for-coach/scenario-1/edit/:id", component: GettingStartedCoachEdit },
  { path: "/getting-started/guide-for-coach/scenario-1", component: GettingStartedCoachViewAll },


  { path: "/getting-started/guide-for-coach/scenario-2/add", component: GettingStartedscenario2CoachAdd },
  { path: "/getting-started/guide-for-coach/scenario-2/edit/:id", component: GettingStartedscenario2CoachEdit },
  { path: "/getting-started/guide-for-coach/scenario-2", component: GettingStartedCoachscenario2ViewAll },

  { path: "/getting-started/guide-for-athlete", component: GettingStartedAthleteViewAll },
  { path: "/getting-started/guide-for-athlete/add", component: GettingStartedAthleteAdd},
  { path: "/getting-started/guide-for-athlete/edit/:id", component: GettingStartedAthleteEdit},

];

export const notPrivateRoutes = [
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/reset-password/:token", component: ResetPassword },
];
